import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _10fe3a03 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _ffe2d8e6 = () => interopDefault(import('../pages/concertagenda/index.vue' /* webpackChunkName: "pages/concertagenda/index" */))
const _47b0b110 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _903cbbf2 = () => interopDefault(import('../pages/doneer.vue' /* webpackChunkName: "pages/doneer" */))
const _f85199ac = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4c68036e = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _2a3b949c = () => interopDefault(import('../pages/form.vue' /* webpackChunkName: "pages/form" */))
const _409fdb08 = () => interopDefault(import('../pages/gift.vue' /* webpackChunkName: "pages/gift" */))
const _e3e5cd3c = () => interopDefault(import('../pages/nieuws/index.vue' /* webpackChunkName: "pages/nieuws/index" */))
const _3926fe16 = () => interopDefault(import('../pages/radio/index.vue' /* webpackChunkName: "pages/radio/index" */))
const _de8742d4 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _4c73cc5c = () => interopDefault(import('../pages/zoeken.vue' /* webpackChunkName: "pages/zoeken" */))
const _8f7ee570 = () => interopDefault(import('../pages/auth/profiel.vue' /* webpackChunkName: "pages/auth/profiel" */))
const _25896e86 = () => interopDefault(import('../pages/auth/registreren/index.vue' /* webpackChunkName: "pages/auth/registreren/index" */))
const _3100291e = () => interopDefault(import('../pages/auth/verifieren.vue' /* webpackChunkName: "pages/auth/verifieren" */))
const _0f894fd9 = () => interopDefault(import('../pages/auth/wachtwoord-vergeten/index.vue' /* webpackChunkName: "pages/auth/wachtwoord-vergeten/index" */))
const _0653795b = () => interopDefault(import('../pages/auth/oauth/start.vue' /* webpackChunkName: "pages/auth/oauth/start" */))
const _7fdfc3f8 = () => interopDefault(import('../pages/auth/registreren/gratis.vue' /* webpackChunkName: "pages/auth/registreren/gratis" */))
const _4819f580 = () => interopDefault(import('../pages/auth/wachtwoord-vergeten/token.vue' /* webpackChunkName: "pages/auth/wachtwoord-vergeten/token" */))
const _e7530fcc = () => interopDefault(import('../pages/nieuws/_slug.vue' /* webpackChunkName: "pages/nieuws/_slug" */))
const _45cb90d1 = () => interopDefault(import('../pages/radio/_slug/index.vue' /* webpackChunkName: "pages/radio/_slug/index" */))
const _ba12dd5e = () => interopDefault(import('../pages/video/_slug/index.vue' /* webpackChunkName: "pages/video/_slug/index" */))
const _d428c25a = () => interopDefault(import('../pages/radio/_slug/_broadcast.vue' /* webpackChunkName: "pages/radio/_slug/_broadcast" */))
const _eeb10be6 = () => interopDefault(import('../pages/video/_slug/_video.vue' /* webpackChunkName: "pages/video/_slug/_video" */))
const _ccd202fc = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth",
    component: _10fe3a03,
    pathToRegexpOptions: {"strict":true},
    name: "auth___nl"
  }, {
    path: "/concertagenda",
    component: _ffe2d8e6,
    pathToRegexpOptions: {"strict":true},
    name: "concertagenda___nl"
  }, {
    path: "/contact",
    component: _47b0b110,
    pathToRegexpOptions: {"strict":true},
    name: "contact___nl"
  }, {
    path: "/doneer",
    component: _903cbbf2,
    pathToRegexpOptions: {"strict":true},
    name: "doneer___nl"
  }, {
    path: "/en",
    component: _f85199ac,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/faq",
    component: _4c68036e,
    pathToRegexpOptions: {"strict":true},
    name: "faq___nl"
  }, {
    path: "/form",
    component: _2a3b949c,
    pathToRegexpOptions: {"strict":true},
    name: "form___nl"
  }, {
    path: "/gift",
    component: _409fdb08,
    pathToRegexpOptions: {"strict":true},
    name: "gift___nl"
  }, {
    path: "/nieuws",
    component: _e3e5cd3c,
    pathToRegexpOptions: {"strict":true},
    name: "nieuws___nl"
  }, {
    path: "/radio",
    component: _3926fe16,
    pathToRegexpOptions: {"strict":true},
    name: "radio___nl"
  }, {
    path: "/video",
    component: _de8742d4,
    pathToRegexpOptions: {"strict":true},
    name: "video___nl"
  }, {
    path: "/zoeken",
    component: _4c73cc5c,
    pathToRegexpOptions: {"strict":true},
    name: "zoeken___nl"
  }, {
    path: "/auth/profiel",
    component: _8f7ee570,
    pathToRegexpOptions: {"strict":true},
    name: "auth-profiel___nl"
  }, {
    path: "/auth/registreren",
    component: _25896e86,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren___nl"
  }, {
    path: "/auth/verifieren",
    component: _3100291e,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verifieren___nl"
  }, {
    path: "/auth/wachtwoord-vergeten",
    component: _0f894fd9,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten___nl"
  }, {
    path: "/en/auth",
    component: _10fe3a03,
    pathToRegexpOptions: {"strict":true},
    name: "auth___en"
  }, {
    path: "/en/concertagenda",
    component: _ffe2d8e6,
    pathToRegexpOptions: {"strict":true},
    name: "concertagenda___en"
  }, {
    path: "/en/contact",
    component: _47b0b110,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en"
  }, {
    path: "/en/doneer",
    component: _903cbbf2,
    pathToRegexpOptions: {"strict":true},
    name: "doneer___en"
  }, {
    path: "/en/faq",
    component: _4c68036e,
    pathToRegexpOptions: {"strict":true},
    name: "faq___en"
  }, {
    path: "/en/form",
    component: _2a3b949c,
    pathToRegexpOptions: {"strict":true},
    name: "form___en"
  }, {
    path: "/en/gift",
    component: _409fdb08,
    pathToRegexpOptions: {"strict":true},
    name: "gift___en"
  }, {
    path: "/en/nieuws",
    component: _e3e5cd3c,
    pathToRegexpOptions: {"strict":true},
    name: "nieuws___en"
  }, {
    path: "/en/radio",
    component: _3926fe16,
    pathToRegexpOptions: {"strict":true},
    name: "radio___en"
  }, {
    path: "/en/video",
    component: _de8742d4,
    pathToRegexpOptions: {"strict":true},
    name: "video___en"
  }, {
    path: "/en/zoeken",
    component: _4c73cc5c,
    pathToRegexpOptions: {"strict":true},
    name: "zoeken___en"
  }, {
    path: "/auth/oauth/start",
    component: _0653795b,
    pathToRegexpOptions: {"strict":true},
    name: "auth-oauth-start___nl"
  }, {
    path: "/auth/registreren/gratis",
    component: _7fdfc3f8,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren-gratis___nl"
  }, {
    path: "/auth/wachtwoord-vergeten/token",
    component: _4819f580,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten-token___nl"
  }, {
    path: "/en/auth/profiel",
    component: _8f7ee570,
    pathToRegexpOptions: {"strict":true},
    name: "auth-profiel___en"
  }, {
    path: "/en/auth/registreren",
    component: _25896e86,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren___en"
  }, {
    path: "/en/auth/verifieren",
    component: _3100291e,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verifieren___en"
  }, {
    path: "/en/auth/wachtwoord-vergeten",
    component: _0f894fd9,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten___en"
  }, {
    path: "/en/auth/oauth/start",
    component: _0653795b,
    pathToRegexpOptions: {"strict":true},
    name: "auth-oauth-start___en"
  }, {
    path: "/en/auth/registreren/gratis",
    component: _7fdfc3f8,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registreren-gratis___en"
  }, {
    path: "/en/auth/wachtwoord-vergeten/token",
    component: _4819f580,
    pathToRegexpOptions: {"strict":true},
    name: "auth-wachtwoord-vergeten-token___en"
  }, {
    path: "/en/nieuws/:slug",
    component: _e7530fcc,
    pathToRegexpOptions: {"strict":true},
    name: "nieuws-slug___en"
  }, {
    path: "/en/radio/:slug",
    component: _45cb90d1,
    pathToRegexpOptions: {"strict":true},
    name: "radio-slug___en"
  }, {
    path: "/en/video/:slug",
    component: _ba12dd5e,
    pathToRegexpOptions: {"strict":true},
    name: "video-slug___en"
  }, {
    path: "/en/radio/:slug/:broadcast",
    component: _d428c25a,
    pathToRegexpOptions: {"strict":true},
    name: "radio-slug-broadcast___en"
  }, {
    path: "/en/video/:slug/:video",
    component: _eeb10be6,
    pathToRegexpOptions: {"strict":true},
    name: "video-slug-video___en"
  }, {
    path: "/nieuws/:slug",
    component: _e7530fcc,
    pathToRegexpOptions: {"strict":true},
    name: "nieuws-slug___nl"
  }, {
    path: "/radio/:slug",
    component: _45cb90d1,
    pathToRegexpOptions: {"strict":true},
    name: "radio-slug___nl"
  }, {
    path: "/video/:slug",
    component: _ba12dd5e,
    pathToRegexpOptions: {"strict":true},
    name: "video-slug___nl"
  }, {
    path: "/radio/:slug/:broadcast",
    component: _d428c25a,
    pathToRegexpOptions: {"strict":true},
    name: "radio-slug-broadcast___nl"
  }, {
    path: "/video/:slug/:video",
    component: _eeb10be6,
    pathToRegexpOptions: {"strict":true},
    name: "video-slug-video___nl"
  }, {
    path: "/en/*",
    component: _ccd202fc,
    pathToRegexpOptions: {"strict":true},
    name: "*___en"
  }, {
    path: "/",
    component: _f85199ac,
    pathToRegexpOptions: {"strict":true},
    name: "index___nl"
  }, {
    path: "/*",
    component: _ccd202fc,
    pathToRegexpOptions: {"strict":true},
    name: "*___nl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
